import n from "./sequiter-markdown.vue2.js";
import { openBlock as o, createElementBlock as r, normalizeClass as t } from "vue";
import s from "../../_virtual/_plugin-vue_export-helper.js";
const a = ["innerHTML"];
function i(e, p, c, m, l, f) {
  return o(), r("span", {
    class: t(e.$options.name),
    innerHTML: e.htmlContent
  }, null, 10, a);
}
const $ = /* @__PURE__ */ s(n, [["render", i]]);
export {
  $ as default
};
//# sourceMappingURL=sequiter-markdown.vue.js.map
